import {Pipe, PipeTransform} from '@angular/core'

export const REGIONAL_DIRECTORY_CSS_ID = 'regional-directory'

@Pipe({name: 'regionalDirectoryCssId', pure: true, standalone: true})
export class RegionalDirectoryCssIdPipe implements PipeTransform {
  transform(index: number): string {
    return `${REGIONAL_DIRECTORY_CSS_ID}-${index}`
  }
}
